import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

export const RupayIcon = ({ height, width }: { height: any; width: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" accessible={false} tabIndex={-1}>
      <Defs>
        <ClipPath id="clip-rupay">
          <Rect width="32" height="32" accessible={false} tabIndex={-1} />
        </ClipPath>
      </Defs>
      <G id="rupay" clipPath="url(#clip-rupay)" accessible={false} tabIndex={-1}>
        <G id="rupay-2" data-name="rupay" transform="translate(4 3.016)" accessible={false} tabIndex={-1}>
          <Path
            id="Fill-1"
            d="M167.517,11.731a.67.67,0,0,1-.695.455h-.7l.275-1.023.732,0A.39.39,0,0,1,167.517,11.731Zm1.462-.478c.113-.9-.569-1.269-1.421-1.269h-2.238L164,14.8h1.422l.4-1.484,1.133.007a2.062,2.062,0,0,0,2.025-2.068Z"
            transform="translate(-155.45 0)"
            fill="#2b2c6e"
            fillRule="evenodd"
            accessible={false}
            tabIndex={-1}
          />
          <Path
            id="Fill-2"
            d="M91.069,35.234h1.3l-.534,2.055s-.133.458.3.494c.339.028.591-.376.673-.65.108-.359.53-1.9.53-1.9h1.336l-1.017,3.5H92.483l.143-.5a1.852,1.852,0,0,1-1.479.639c-.786-.077-.854-.647-.718-1.359.067-.349.639-2.278.639-2.278"
            transform="translate(-85.662 -23.934)"
            fill="#2b2c6e"
            fillRule="evenodd"
            accessible={false}
            tabIndex={-1}
          />
          <G id="Group" transform="translate(0 9.984)" accessible={false} tabIndex={-1}>
            <G id="Group-7" transform="translate(0 0)" accessible={false} tabIndex={-1}>
              <Path
                id="Fill-3"
                d="M246.67,25.859c-.222.056-.492.087-.545-.115-.147-.553,1.148-.715,1.148-.715A.9.9,0,0,1,246.67,25.859Zm1.959-1.012c.171-.582.387-1.133.213-1.438-.266-.467-.747-.508-1.451-.508a1.865,1.865,0,0,0-2.051,1.182h1.295a.569.569,0,0,1,.6-.365c.43.022.407.318.248.481-.278.287-1.046.128-1.9.423a1.439,1.439,0,0,0-.842,1.625c.156.378.448.426.841.465a1.771,1.771,0,0,0,1.34-.5c0,.229.006.357.006.357H248.3l0-.128s-.121-.032-.108-.2c.01-.125.245-.726.441-1.394Z"
                transform="translate(-231.945 -21.757)"
                fill="#2b2c6e"
                fillRule="evenodd"
                accessible={false}
                tabIndex={-1}
              />
              <Path
                id="Fill-5"
                d="M3.576,2.72c-.184.426-.754.377-.754.377l-.664,0,.242-.9.885,0C3.6,2.194,3.695,2.445,3.576,2.72ZM5.084,2.1C5.2,1.21,4.41.984,3.558.984H1.321L0,5.8H1.422l.444-1.634.8.007s.329-.019.336.29c.007.33-.244.935-.228,1.338H4.231l0-.128s-.121-.032-.108-.2a5.082,5.082,0,0,1,.186-.6,1.845,1.845,0,0,0,.147-.708c-.011-.322-.213-.471-.5-.576C4.857,3.372,5.084,2.1,5.084,2.1Z"
                transform="translate(0 -0.984)"
                fill="#2b2c6e"
                fillRule="evenodd"
                accessible={false}
                tabIndex={-1}
              />
              <Path
                id="Fill-6"
                d="M314.673,26.234h1.321v2.1l1.143-2.1h1.212L315.9,30.477a2.149,2.149,0,0,1-.508.544,1.159,1.159,0,0,1-.6.154c-.483,0-1.065-.005-1.065-.005l.281-1.011h.455a.5.5,0,0,0,.288-.124.506.506,0,0,0,.116-.339c0-.215-.2-3.46-.2-3.46"
                transform="translate(-297.372 -24.918)"
                fill="#2b2c6e"
                fillRule="evenodd"
                accessible={false}
                tabIndex={-1}
              />
            </G>
            <Path
              id="Fill-8"
              d="M407.109,10.734l-1.525,5.3,2.854-2.652-1.329-2.652"
              transform="translate(-384.438 -10.226)"
              fill="#197845"
              fillRule="evenodd"
              accessible={false}
              tabIndex={-1}
            />
            <Path
              id="Fill-9"
              d="M388.359,10.734l-1.525,5.3,2.854-2.652-1.329-2.652"
              transform="translate(-366.666 -10.226)"
              fill="#e06b2b"
              fillRule="evenodd"
              accessible={false}
              tabIndex={-1}
            />
          </G>
        </G>
      </G>
    </Svg>
  )
}
